<template>
  <div style="height: 100%;">
    <span style="font-size: 14px;color: rgba(0, 0, 0, 0.85);font-weight: bold">
      选择时间:
      </span>
    <a-range-picker
        style="width:320px;margin-right:12px"
        v-model="value1"
        show-time
        :change="onChange()"
    />

    <span style="font-size: 14px;color: rgba(0, 0, 0, 0.85);font-weight: bold">
      日志级别:
      </span>
    <a-select
        style="width:250px;margin-right:12px"
        allowClear
        v-model="selectValue"
        placeholder="请选择"
        :change="handleChange()"
    >
      <a-select-option value="info">info</a-select-option>
      <a-select-option value="debug">debug</a-select-option>
      <a-select-option value="warning">warning</a-select-option>
      <a-select-option value="error">error</a-select-option>
      <a-select-option value="critical">critical</a-select-option>
      <!--      {this.selectOption.map(item => (-->
      <!--      <a-select-option value={item.value}>{item.name}</a-select-option>-->
      <!--      ))}-->
    </a-select>
    <span style="font-size: 14px;color: rgba(0, 0, 0, 0.85);font-weight: bold;">
      日志信息:
      </span>
    <a-input style="width:250px;margin-right:12px"
             v-model="message"
    >
    </a-input>
    <a-button-group>
      <a-button type="primary" @click="searchList()">
        {{ $t('search') }}
      </a-button>
      <a-button type="primary" @click="clera()" style="margin-left: 3px">
        {{ $t('common_reset') }}
      </a-button>
    </a-button-group>
    <ml-table
        :columns="columns"
        :data-source="serverLog"
        :pagination="pagination"
        style="margin-top: 5px"
        :canChangeColWidth="true"
        @change="handleTableChange"
        :loading="loading"
    >

    </ml-table>

  </div>
</template>

<script>
import {GetServerLogVO, IotExtranetLogServiceProxy} from "@/service-proxies/app-v2/iotmodel-storage.service-proxies";
import dayjs from "dayjs";

const ecsp = new IotExtranetLogServiceProxy()
export default {
  name: "ServerLog",
  data() {
    return {
      value1: undefined,
      message: '',
      selectValue: undefined,
      startTime: '',
      endTime: '',
      serverLog: [],
      loading : true,
      pagination:{
        current:1,
        pageSize:20,
        total:0,
        size: "normal",
        showSizeChanger: true,
      },
      columns: [
        {
          title: "时间",
          key: "timestamp",
          dataIndex: "timestamp",
          width: 150,
          customRender: (time) => dayjs(time).format("YYYY-MM-DD HH:mm:ss"),
        },
        {
          title: "日志级别",
          key: "level",
          dataIndex: "level",
          width: 100,
        },
        {
          title: "线程id",
          key: "threadId",
          dataIndex: "threadId"
        },
        {
          title: "日志信息",
          key: "message",
          dataIndex: "message"
        },
      ]
    }
  },

  created() {
    // this.startTime = dayjs().subtract(6, 'day').valueOf()
    // this.endTime = dayjs().valueOf()
    // this.data = []
    // this.search()
    this.getTableData()
  },
  methods: {
    getData() {
    },
    handleChange() {

    },
    handleTableChange(e) {
      if (e){
        this.pagination.current = e.current
        this.pagination.pageSize = e.pageSize
      }
      this.getTableData()
    },
    searchList() {
      this.pagination.current = 1
      this.getTableData()
    },
    onChange() {
      if (this.value1 && this.value1.length > 0) {
        this.startTime = Date.parse(new Date(this.value1[0]._d)).toString()
        this.endTime = Date.parse(new Date(this.value1[1]._d)).toString()
      }else{
        this.startTime = ''
        this.endTime = ''
      }
    },
    clera() {
      this.value1 = undefined
      this.selectValue = undefined
      this.message = ''
      this.startTime = ''
      this.endTime = ''
      this.pagination.current = 1
      this.pagination.pageSize = 20
      // this.getTableData()
    },
    getTableData(){
      this.loading =true
      let sValue = this.selectValue == undefined ? '' : this.selectValue
      let params = {
        current : this.pagination.current,
        size : this.pagination.pageSize,
        level : sValue,
        startTime : this.startTime,
        endTime : this.endTime,
        message : this.message
      }
      const gs = new GetServerLogVO()
      gs.init(params)
      ecsp.getIotServerLog(gs).then((res) => {
        if (res){
          this.serverLog = res.items
          this.pagination.total = res.totalCount
        }

      }).finally(()=>{
        this.loading = false
      })
    }
  }

}
</script>

<style scoped>

</style>